import Landing from '../components/Landing';
import { useLocale } from '../Locale';

const Experience = () =>{
    const locale = useLocale();
    let pageInfo = {
        name: "experience",
        title:"car.title",
        headline: "car.headline",
        text:"car.text",
        nextText:"car.nextNav",
        nextUrl:"discover",
        prevText:"car.prevNav",
        prevUrl:"explore",
        comingSoonText:"car.comingSoonText",
        buttonText:"car.ctaText",
        //buttonUrl:"car.ctaUrl"
        buttonUrl: process.env.NODE_ENV === 'production' ? new URL(`${window.PUBLIC_URL}/ariya-${locale}.html`,window.location.href).toString() : 'nissan-ariya'
    }
    
    return(
        <Landing pageInfo={pageInfo} />
    )
}

export default Experience;